/* ==========================================================================
   Two Forces Split Section — vanilla JS
   Handles optional fade-in-on-scroll animation via IntersectionObserver.
   ========================================================================== */

(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var enableAnimation = section.dataset.enableAnimation === 'true';
    if (!enableAnimation) return;

    section.classList.add('two-forces--animate');

    if (!('IntersectionObserver' in window)) {
      section.classList.add('two-forces--in-view');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('two-forces--in-view');
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  }

  function initAll() {
    document.querySelectorAll('[data-two-forces]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-two-forces]');
    if (section) {
      section.dataset.initialized = 'false';
      initSection(section);
    }
  });
})();